import cn from 'classnames';
import { FC } from 'react';

import { DEFAULT_MEDICAL_IMAGE_HEIGHT } from '@/shared/config';
import { RCGuides } from '@/shared/graphics/RenderComponents/RCGuides';

import type { FullHeadMprSliceGuideView } from '../../config';

import styles from './FullHeadMprSliceGuides.module.scss';

type FullHeadMprSliceGuidesProps = {
  guides: FullHeadMprSliceGuideView[];
  hoveredTileID: string;
  className?: string;
  onHoveredTileChanged: (tileID: string) => void;
  onLineClick: (tileID: string) => void;
};

export const FullHeadMprSliceGuides: FC<FullHeadMprSliceGuidesProps> = (
  props,
) => {
  const {
    guides,
    hoveredTileID,
    className,
    onHoveredTileChanged,
    onLineClick,
  } = props;

  const firstGuide = guides.at(0);

  if (!firstGuide) {
    return null;
  }

  const guideWidth =
    DEFAULT_MEDICAL_IMAGE_HEIGHT *
    (firstGuide.imageWidthPx / firstGuide.imageHeightPx);

  return (
    <div
      className={cn(styles.container, className)}
      data-component="mpr-slice-guides"
    >
      {guides.map((guide) => (
        <div
          key={guide.id}
          className={styles.guide}
          style={{ width: guideWidth }}
        >
          <img className={styles.guideImage} src={guide.pngUrl} alt="" />
          <div className={styles.linesOverlay}>
            <RCGuides
              imageSize={{
                width: guide.imageWidthPx,
                height: guide.imageHeightPx,
              }}
              guides={guide.lines}
              hoveredGuide={hoveredTileID}
              onHoveredGuideChanged={onHoveredTileChanged}
              onGuideClick={onLineClick}
            />
          </div>
        </div>
      ))}
    </div>
  );
};
